/* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */
/* eslint-disable @atlassian/relay/unused-fields */
import { useCallback } from 'react';
import { fetchQuery, graphql, useRelayEnvironment } from 'react-relay';
import type { RelayObservable } from 'relay-runtime/lib/network/RelayObservable';
import type {
	useVersionsRefetchQuery,
	useVersionsRefetchQuery$data,
} from '@atlassian/jira-relay/src/__generated__/useVersionsRefetchQuery.graphql';
import { useBoardAri } from '../use-board-ari/index.tsx';

export type RefetchVersions = (
	jiraProjectIds: string[],
) => RelayObservable<useVersionsRefetchQuery$data>;

export const useVersionsRefetch = () => {
	const environment = useRelayEnvironment();
	const boardAri = useBoardAri();
	return useCallback<RefetchVersions>(
		(jiraProjectIds) =>
			fetchQuery<useVersionsRefetchQuery>(
				environment,
				graphql`
					query useVersionsRefetchQuery($jiraProjectIds: [ID!]!, $boardId: ID!) {
						jira @optIn(to: ["JiraVersionsForProjects"]) {
							versionsForProjects(
								jiraProjectIds: $jiraProjectIds
								first: 500
								filter: [UNRELEASED]
							)
								@required(action: THROW)
								@connection(key: "versionBacklogPanelRelay_versionsForProjects") {
								edges {
									...versionPanel_softwareVersionBacklogPanelRelay_jiraVersionEdges
									node {
										versionId
									}
								}
							}
						}
					}
				`,
				{
					jiraProjectIds,
					boardId: boardAri,
				},
			),
		[boardAri, environment],
	);
};
